var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408,
    height: 66,
    viewBox: "0 0 408 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "snail-a",
    d: "M19.1 8v4.4c1.6 0 3.5.4 4.9 1l4.2-2.9a3.5 3.5 0 0 1 3.4-3.4c1.8 0 3.3 1.6 3.3 3.6 0 2.6-2.7 4.4-4.9 3.1l-2.8 2c3.9 4.4 2.8 12 2.5 17.4 5.9 0 18.3 1.4 18.3 8.2 0 7.1-7.7 19.3-9.8 19.5-.5 0-.9-.3-1.3-.9a16 16 0 0 1-11.4 7.8h-.3c-9.4 1.3-18.3-5.3-18.3-14.4 0-2.6.7-5 2-7C3.7 44.3 0 40 0 34.8c0-5.7 6.4-19 15.4-22v-5c-2.7-1.9-1.2-5.7 2-5.7 3.7 0 4.9 4.4 1.7 6zM9 18.2c.6 0 .9 1 .6 2.1-.2 1.1-.9 2-1.5 2-.8 0-.8-1.7-.3-2.8-2.2 2.7-4 5.9-5.2 8.7-1.2 3.2-2.1 6.3-1 9.6 1.7 4.4 6 7.1 10.6 7.9v-1l-2.3-.3c-.4 0-.3-.7 0-.6 2 .3 4.3.6 6 1.2.3.2 0 .7-.3.6-.8-.4-1.8-.6-2.8-.8v1c6 .8 13.1-2 15.3-8 .4-1 .6-2.2.6-3.3 0-5.8 1.8-14.2-2.3-18.7l-.4.2c-1.3.3-2.4-.7-2.3-2.1a11 11 0 0 0-6.6-.8c-3 .6-5.9 2.6-8.2 5.2H9zm3.3 2.7c.2 0 .3.1.4.3 1-.7 1.7.6 1.3 2.2-.3 1.4-1.2 2.5-2 2.5s-1.1-1.1-.8-2.5l.2-.6V22c.2-.6.6-1.1 1-1.1zM29 13.7c-.9-.8-.8-1.4-1-1.7l-4 2.4c-.1.8.2 1.7 1.2 1.6l3.8-2.3zM27.7 41a15 15 0 0 1-6.4 5.2c-.8 2.2-1.3 4.8-1.3 7.5 0 5.9 2.2 11 5.3 13.3 3.5-.6 6.5-2.3 8.7-4.7-3.8-2.1-4-12.4-1.4-16.3-.9-1.2-1.9-2.6-2.8-4.1a15 15 0 0 0-2.1-.9zm-7.5 6c-3.2 1-7 1-10.2.2-6.4 10.1 3.6 20.7 14 19.7-3.5-3.2-4.8-8.7-4.8-13.1 0-2.2.3-4.6 1-6.8zM36 58.9L34.7 61c-1.5-.6-2.7-3.8-2.7-7.7 0-2.6.5-4.9 1.3-6.3L36 58.9zM16 13l2-.4V7.4c-.1-.6-1.6-.5-2 .1V13z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#020D26",
    xlinkHref: "#snail-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A303A",
    xlinkHref: "#snail-a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0A303A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M38.4 60c-3.9 2 .4 2 12.9 0 18.7-3.2 33.7-5.9 71.4 0 37.8 5.6 119.6-16.6 154.5-12.5m13.8.6c23.8 2.3 35.7-4 73.4 2.3M379 53c8.4.6 12.9 3.3 27.8 2.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnail);
export default __webpack_public_path__ + "static/media/snail.4ac54e11ea638b5e48b00dcb31a04693.svg";
export { ForwardRef as ReactComponent };